import { render, staticRenderFns } from "./MealTotal.vue?vue&type=template&id=6990b79a&scoped=true"
import script from "./MealTotal.vue?vue&type=script&lang=js"
export * from "./MealTotal.vue?vue&type=script&lang=js"
import style0 from "./MealTotal.vue?vue&type=style&index=0&id=6990b79a&prod&scoped=true&lang=scss"
import style1 from "./MealTotal.vue?vue&type=style&index=1&id=6990b79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990b79a",
  null
  
)

export default component.exports